import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const HOSTNAME = window.location.hostname;
export const CUSTOM_HOST = HOSTNAME !== new URL(BACKEND_URL).hostname && HOSTNAME !== "localhost" && !/(^|\.)(boshq\.com\.au|emergentagent\.com|emergent\.host|emergentcf\.cloud)$/.test(HOSTNAME);
export const API = CUSTOM_HOST ? `${window.location.origin}/api` : `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
export const profileUnlock = { token: "" };

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bos_token");
  const a = localStorage.getItem("bos_account");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (a) cfg.headers["X-Account-Id"] = a;
  if (profileUnlock.token) cfg.headers["X-Profile-Unlock"] = profileUnlock.token;
  return cfg;
});

api.interceptors.response.use((r) => r, (e) => {
  const url = e?.config?.url || "";
  if (e?.response?.status === 401 && !url.startsWith("/auth/") && localStorage.getItem("bos_token")) {
    localStorage.removeItem("bos_token");
    window.location.assign("/login?expired=1");
  }
  return Promise.reject(e);
});


export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const aud = (n) =>
  "A$" + Number(n || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short", timeZone: "Australia/Sydney" }) : "—");
export const auDate = (s) => {
  if (!s) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return new Date(s).toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Australia/Sydney" });
};

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const ROLE_LABEL = { agency_owner: "Enterprise Owner", subaccount_admin: "Entity Admin", staff: "Staff" };
export const splitName = (n) => { const p = (n || "").trim().split(/\s+/); return { first_name: p[0] || "", last_name: p.slice(1).join(" ") }; };
